module.exports = __webpack_public_path__ + "static/media/destination_bg.9b6b3d30.png";